import core from '@gin-betting/core';

const { appServiceLocator } = core;

let prevMinBet = 0;

export default function getMinBet(): {
    prevMinBet: number;
    request: () => Promise<number>;
} {
    return {
        prevMinBet,
        request: () =>
            appServiceLocator
                .get('apiClient')
                .makeRequest({
                    method: 'getMinBet',
                    variables: {},
                })
                .then(response => {
                    prevMinBet = Number(response.data.minBet.value);

                    return prevMinBet;
                })
                .catch(error => {
                    console.error(error);

                    return prevMinBet;
                }),
    };
}
